import { createApp } from 'vue'
import App from './App.vue'

import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import './styles/tokens.css'
import './styles/tailwind.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue' // 导入所有图标
import router from './router'


window.__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = true

// 初始化全局事件监听
setupGlobalEventListeners();

const app = createApp(App)

// 注册所有 Element Plus 图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}

// 页面卸载事件处理
function handlePageUnload() {
    const currentVisitStr = sessionStorage.getItem('current_visit');

    // 检查是否正在发送中
    const isSendingLog = sessionStorage.getItem('is_sending_log') === 'true';

    if (currentVisitStr && !isSendingLog) {
        // 设置发送状态
        sessionStorage.setItem('is_sending_log', 'true');

        const currentVisit = JSON.parse(currentVisitStr);
        const duration = Date.now() - currentVisit.enterTime;

        // 确保时间格式正确
        if (currentVisit.timestamp && currentVisit.timestamp.includes('T')) {
            const date = new Date(currentVisit.timestamp);
            currentVisit.timestamp = formatServerTime(date);
        }

        // 使用 navigator.sendBeacon 确保在页面卸载时也能发送
        const data = JSON.stringify({
            ...currentVisit,
            duration: duration,
            isPageUnload: true
        });

        if (navigator.sendBeacon) {
            const success = navigator.sendBeacon('/api/log/page-track', new Blob([data], {type: 'application/json'}));

            if (success) {
                sessionStorage.removeItem('current_visit');
            } else {
                // 发送失败，重置发送状态
                sessionStorage.setItem('is_sending_log', 'false');
            }
        } else {
            try {
                const xhr = new XMLHttpRequest();
                xhr.open('POST', '/api/log/page-track', false);
                xhr.setRequestHeader('Content-Type', 'application/json');
                xhr.send(data);

                if (xhr.status === 200) {
                    sessionStorage.removeItem('current_visit');
                } else {
                    sessionStorage.setItem('is_sending_log', 'false');
                }
            } catch (error) {
                sessionStorage.setItem('is_sending_log', 'false');
            }
        }
    } else {

    }
}

// 页面可见性变化处理
function handleVisibilityChange() {
    if (document.visibilityState === 'hidden') {
        handlePageUnload();
    } else {
        // 页面重新显示时重置发送状态
        sessionStorage.setItem('is_sending_log', 'false');
    }
}

// 注册全局事件监听器
function setupGlobalEventListeners() {

    // 初始化发送状态
    sessionStorage.setItem('is_sending_log', 'false');

    // 页面卸载前（刷新、关闭）
    window.addEventListener('beforeunload', handlePageUnload);

    // 页面可见性变化
    document.addEventListener('visibilitychange', handleVisibilityChange);

    // 页面加载完成后初始化
    if (document.readyState === 'loading') {
        window.addEventListener('DOMContentLoaded', initializePageVisit);
    } else {
        initializePageVisit();
    }
}

function initializePageVisit() {
    const currentPath = window.location.hash ? window.location.hash.substring(1) : '/';

    // 重置发送状态
    sessionStorage.setItem('is_sending_log', 'false');

    // 检查是否已经有访问记录
    const currentVisitStr = sessionStorage.getItem('current_visit');
    if (!currentVisitStr && currentPath) {
        const visitData = {
            page: currentPath,
            referrer: document.referrer || '直接访问',
            userAgent: navigator.userAgent,
            timestamp: formatServerTime(),
            enterTime: Date.now()
        };
        sessionStorage.setItem('current_visit', JSON.stringify(visitData));
    } else if (currentVisitStr) {

    } else {

    }
}

function formatServerTime(date = new Date()) {
    return date.getFullYear() + '-' +
        String(date.getMonth() + 1).padStart(2, '0') + '-' +
        String(date.getDate()).padStart(2, '0') + ' ' +
        String(date.getHours()).padStart(2, '0') + ':' +
        String(date.getMinutes()).padStart(2, '0') + ':' +
        String(date.getSeconds()).padStart(2, '0') + '.' +
        String(date.getMilliseconds()).padStart(6, '0');
}

app.use(router)
app.use(ElementPlus)
app.mount('#app')

// 挂载后再次检查，确保事件监听器正常工作
app.mounted = () => {
    console.log('Vue 应用已挂载，事件监听器已设置');
    console.log('当前 sessionStorage:', {
        current_visit: sessionStorage.getItem('current_visit'),
        is_sending_log: sessionStorage.getItem('is_sending_log')
    });
};